import { getWindowChromeThemeColor } from "./windowChromeTheme.js";
import { BRAND_GOLD } from "./brandGold.js";

/**
 * Comparison-page action buttons: transparent outlined + dark contained.
 * Use for header actions, modal footers, settings/filter popups, confirms.
 */

export function outlinedActionButtonSx() {
    return {
        color: getWindowChromeThemeColor("#333333", BRAND_GOLD),
        borderColor: getWindowChromeThemeColor("#999999", BRAND_GOLD),
        textTransform: "none",
        backgroundColor: "transparent",
        boxShadow: "none",
        "&:hover": {
            borderColor: getWindowChromeThemeColor("#666666", BRAND_GOLD),
            backgroundColor: getWindowChromeThemeColor(
                "rgba(0,0,0,0.04)",
                "rgba(244,204,142,0.08)",
            ),
            boxShadow: "none",
        },
        "&.Mui-disabled": {
            color: getWindowChromeThemeColor("rgba(51,51,51,0.38)", "rgba(244,204,142,0.35)"),
            borderColor: getWindowChromeThemeColor("rgba(153,153,153,0.4)", "rgba(244,204,142,0.25)"),
            backgroundColor: "transparent",
        },
    };
}

export function containedActionButtonSx() {
    return {
        color: getWindowChromeThemeColor("#ffffff", BRAND_GOLD),
        backgroundColor: getWindowChromeThemeColor("#424242", "#000000"),
        textTransform: "none",
        boxShadow: "none",
        border: "none",
        "&:hover": {
            backgroundColor: getWindowChromeThemeColor("#616161", "#1a1a1a"),
            boxShadow: "none",
        },
        "&.MuiButton-contained": {
            color: getWindowChromeThemeColor("#ffffff", BRAND_GOLD),
            backgroundColor: getWindowChromeThemeColor("#424242", "#000000"),
        },
        "&.MuiButton-contained:hover": {
            backgroundColor: getWindowChromeThemeColor("#616161", "#1a1a1a"),
            boxShadow: "none",
        },
        "&.Mui-disabled": {
            color: getWindowChromeThemeColor("rgba(255,255,255,0.5)", "rgba(244,204,142,0.35)"),
            backgroundColor: getWindowChromeThemeColor("#9e9e9e", "#1a1a1a"),
        },
    };
}

/** Default sx for Comparison-style small header actions (History / View / Email). */
export function comparisonHeaderButtonSx() {
    return {
        ...outlinedActionButtonSx(),
        textTransform: "none",
    };
}

/**
 * Comparison / Site Inventory field chrome: muted 14px labels, field fill, gold text.
 * Use on outlined TextField / Select / DatePicker textField slotProps.
 */
export function comparisonFieldSx() {
    return {
        "& .MuiOutlinedInput-root": {
            color: getWindowChromeThemeColor("#333333", BRAND_GOLD),
            backgroundColor: getWindowChromeThemeColor("#ffffff", "#2d2d2d"),
            fontSize: "14px",
            "& fieldset": {
                borderColor: getWindowChromeThemeColor("#cccccc", "rgba(244,204,142,0.5)"),
            },
            "&:hover fieldset": {
                borderColor: getWindowChromeThemeColor("#666666", BRAND_GOLD),
            },
            "&.Mui-focused fieldset": {
                borderColor: getWindowChromeThemeColor("#666666", BRAND_GOLD),
            },
        },
        "& .MuiInputLabel-root": {
            color: getWindowChromeThemeColor("#666666", "#a8abb1"),
            fontSize: "14px",
        },
        "& .MuiInputLabel-root.Mui-focused": {
            color: getWindowChromeThemeColor("#333333", BRAND_GOLD),
        },
        "& .MuiInputBase-input": {
            color: getWindowChromeThemeColor("#333333", BRAND_GOLD),
            fontSize: "14px",
        },
        "& .MuiSelect-select": {
            color: getWindowChromeThemeColor("#333333", BRAND_GOLD),
            fontSize: "14px",
        },
        "& .MuiSvgIcon-root": {
            color: getWindowChromeThemeColor("#666666", "#a8abb1"),
        },
    };
}
